<script lang="ts">
  import { Translations } from "../translations";
  import { fade } from 'svelte/transition';
  import { onMount } from "svelte";

  export let translations: Translations;
  export let errors: any = {};
  export let password: string = "";
  export let passwordRepetition: string = "";
  
  let passwordControl: any;
  let passwordRepetitionControl: any;
  
  onMount(async () => {
    let i18n = {
      "errorMessage": translations.get("Some error occurred"),
      "successLabel": translations.get("Success"),
      "revealPasswordText": translations.get("Show"),
      "hidePasswordText": translations.get("Hide")
    };
    
    passwordControl.i18n = i18n;
    passwordRepetitionControl.i18n = i18n;
  })
</script>

<div in:fade class="wk-grid">
  <div class="wk-column-6">
    <wk-password-input label='{translations.get("Password")}' bind:this={passwordControl} class="wk-column-6" type-class="wk-field-small">
      <input class="wk-field-input"
             id="invitation-form-input-password"
             autocomplete="new-password"
             type='password'
             placeholder='{translations.get("Please enter your password")}'
             name='Password'
             required
             bind:value={password} />
      {#if errors.Password}<span class="wk-field-error field-validation-error">{errors.Password}</span>{/if}
    </wk-password-input>
    <wk-password-input label='{translations.get("PasswordRepetition")}' bind:this={passwordRepetitionControl} class="wk-column-6" type-class="wk-field-small">
      <input class="wk-field-input"
             autocomplete="off"
             type='password'
             placeholder='{translations.get("Please enter your password again")}'
             name='PasswordRepetition'
             required
             bind:value={passwordRepetition} />
      {#if errors.PasswordRepetition}<span class="wk-field-error field-validation-error">{errors.PasswordRepetition}</span>{/if}
    </wk-password-input>
  </div>
  <div class="wk-column-6 wk-idp-password-hint-container">
    <div class="wk-field">
      <p class="wk-hint-title">{translations.get("Security features")}</p>
      <p id="rule-password-length" class="wk-hint" class:wk-text-success={password.length >= 10}>{translations.get("min. 10+ characters")}</p>
      <p id="rule-password-uppercase" class="wk-hint" class:wk-text-success={password.match(/[A-Z]/)}>{translations.get("min. 1 capital letter")}</p>
      <p id="rule-password-lowercase" class="wk-hint" class:wk-text-success={password.match(/[a-z]/)}>{translations.get("min. 1 lower case letter")}</p>
      <p id="rule-password-numbers" class="wk-hint" class:wk-text-success={password.match(/\d/)}>{translations.get("min. 1 number")}</p>
      <p id="rule-password-special-character" class="wk-hint" class:wk-text-success={password.match(/[!?@%*#§$_\-/(){}\[\]]+/)}>{translations.get("min. 1 special character")} {"(!?@%*#§$_-(){}[]/\\)"}</p>
      <p id="rule-password-match" class="wk-hint" class:wk-text-success={password.length > 0 && password === passwordRepetition}>{translations.get("Passwords are matching")}</p>
    </div>
  </div>
</div>

<style lang="scss">
  .wk-idp-password-hint-container {
    padding-left: 2rem;
  }
  .wk-hint {
    font-size: .75rem;
  }
  .wk-hint-title {
    font-size: .75rem;
    text-transform: uppercase;
    color: #353535;
    padding-bottom: .5rem;
  }

</style>